import React from 'react';
import FilterSelectDropdown from 'src/components/10-atoms/filters/FilterSelectDropdown';
const options = [{
        id: undefined,
        title: 'All Questions',
    }, {
        id: true,
        title: 'Answered',
    }, {
        id: false,
        title: 'Unanswered',
    }];
const AnsweredFilter = ({ value, onChange }) => (React.createElement(FilterSelectDropdown, { value: value, onChange: onChange, options: options, title: "Select Answered filter" }));
export default AnsweredFilter;
